// extracted by mini-css-extract-plugin
export default {"page":"LoadingPage-page-TN4QY Page-page-TorHA","logoFull":"LoadingPage-logoFull-_XCIG"};